module.exports = __webpack_public_path__ + "static/media/Gokul-Stage.714207fb.png";